import script from "./headingAndVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./headingAndVideo.vue?vue&type=script&setup=true&lang=js"

import "./headingAndVideo.vue?vue&type=style&index=0&id=40b9820f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40b9820f"]])

export default __exports__